(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-multicolumn"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const toggle = e.target.closest('.deploy-text-toggle');
    const gridItem = e.target.closest('.grid-item.has-deploy-text');

    if (toggle) {
      const columnInner = toggle.closest('.column__inner');
      const expanded = columnInner.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', expanded);
      return;
    }
    if (
      gridItem &&
      !e.target.closest('a, button, input, textarea, select')
    ) {
      const columnInner = gridItem.querySelector('.column__inner');
      if (!columnInner) return;

      const toggleBtn = columnInner.querySelector('.deploy-text-toggle');
      const expanded = columnInner.classList.toggle('is-expanded');

      if (toggleBtn) {
        toggleBtn.setAttribute('aria-expanded', expanded);
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-product-grid-item"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e){
  const swatchLink = e.target.closest('.swatch__link');
  if (!swatchLink) return;
  if (swatchLink.closest('.product-item--b2b')) return;
  e.preventDefault();
}, true);

document.querySelectorAll('.grid-item').forEach(item => {
  const swatches = item.querySelectorAll('.swatches');
  swatches.forEach(swatch => {
    swatch.addEventListener('mouseenter', () => {
      item.classList.add('hide-second-badge');
    });
  });
  item.addEventListener('mouseleave', () => {
    item.classList.remove('hide-second-badge');
  });
});
document.addEventListener('click', function(e) {
  const swatchButton = e.target.closest('[data-swatch-button]');
  
  if (swatchButton) {
    const container = swatchButton.closest('.product-information') || swatchButton.closest('grid-item');
    if (container) {
      container.querySelectorAll('[data-swatch-button]').forEach(btn => {
        btn.classList.remove('is-selected');
      });
      swatchButton.classList.add('is-selected');

      const variantName = swatchButton.getAttribute('data-swatch-variant-name');
      const nameDisplay = container.querySelector('[data-variant-name-display]');
      
      if (nameDisplay && variantName) {
        nameDisplay.style.opacity = '0.3';
        setTimeout(() => {
          nameDisplay.textContent = variantName;
          nameDisplay.style.opacity = '1';
        }, 100);
      }

      // CUSTOM CODE - Update quick-add variant 
      const variantId = swatchButton.getAttribute('data-swatch-variant') || swatchButton.getAttribute('data-variant');
      const variantAvailable = swatchButton.getAttribute('data-variant-available') === 'true';
      
      if (variantId) {
        const productItem = container.closest('[data-grid-item]') || container;
        const variantInput = productItem.querySelector('[data-quick-add-variant]');
        const addToCartButton = productItem.querySelector('[data-add-to-cart]');
        
        if (variantInput) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (addToCartButton) {
          if (variantAvailable) {

            addToCartButton.classList.remove('is-disabled');
            addToCartButton.removeAttribute('aria-disabled');
            addToCartButton.type = 'submit';
            
            const btnText = addToCartButton.querySelector('.btn__text');
            if (btnText) {
              const addToCartText = addToCartButton.getAttribute('data-add-to-cart-text') || addToCartButton.getAttribute('aria-label') || 'Add to cart';
              btnText.textContent = addToCartText;
            }
          } else {
            addToCartButton.classList.add('is-disabled');
            addToCartButton.setAttribute('aria-disabled', 'true');
            addToCartButton.type = 'button';
            const btnText = addToCartButton.querySelector('.btn__text');
            if (btnText) {
              const soldOutText = addToCartButton.getAttribute('data-sold-out-text') || 'Sold out';
              btnText.textContent = soldOutText;
            }
          }
        }
      }
      // END CUSTOM CODE
    }
  }
}, true);

// CUSTOM CODE
document.addEventListener('click', function (e) {
    const swatch = e.target.closest('[data-swatch-button]');
    if (!swatch) return;

    const productItem = swatch.closest('[data-grid-item]');
    if (!productItem) return;
    const priceCents = swatch.dataset.variantPriceCents;
    const compareCents = swatch.dataset.variantCompareAtPriceCents;
    function formatMoneyFromCents(cents) {
      if (cents === '' || cents == null) return '';
      const amount = parseInt(cents, 10);
      if (window.theme && typeof window.theme.formatMoney === 'function' && window.theme.moneyWithCurrencyFormat) {
        try {
          return window.theme.formatMoney(amount, window.theme.moneyWithCurrencyFormat);
        } catch (err) {
        }
      }
      return (amount / 100).toFixed(2);
    }

    const formattedPrice = formatMoneyFromCents(priceCents);
    const formattedCompare = formatMoneyFromCents(compareCents);

    const priceHolder = productItem.querySelector('[data-product-price]');
    if (!priceHolder) return;

    const newPriceEl = priceHolder.querySelector('.new-price') || priceHolder;
    if (formattedPrice) {
      newPriceEl.textContent = formattedPrice;
    }

    let oldPriceEl = priceHolder.querySelector('.old-price');

    if (formattedCompare && formattedCompare !== formattedPrice) {
      if (!oldPriceEl) {
        oldPriceEl = document.createElement('span');
        oldPriceEl.className = 'old-price';
        priceHolder.appendChild(oldPriceEl);
      }
      oldPriceEl.textContent = formattedCompare;
      oldPriceEl.style.display = '';
      priceHolder.classList.add('price--on-sale');
    } else {
      if (oldPriceEl) oldPriceEl.style.display = 'none';
      priceHolder.classList.remove('price--on-sale');
    }

    if (!formattedCompare) {
      newPriceEl.style.color = 'black';
    } else {
      newPriceEl.style.color = 'var(--COLOR-SALE)';
    }

  }, true);

// END CUSTOM CODE
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-variant-grid-item"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e){
  const swatchLink = e.target.closest('.swatch__link');
  if (!swatchLink) return;
  if (swatchLink.closest('.product-item--b2b')) return;
  e.preventDefault();
}, true);

document.querySelectorAll('.grid-item').forEach(item => {
  const swatches = item.querySelectorAll('.swatches');
  swatches.forEach(swatch => {
    swatch.addEventListener('mouseenter', () => {
      item.classList.add('hide-second-badge');
    });
  });
  item.addEventListener('mouseleave', () => {
    item.classList.remove('hide-second-badge');
  });
});
document.addEventListener('click', function(e) {
  const swatchButton = e.target.closest('[data-swatch-button]');
  
  if (swatchButton) {
    const container = swatchButton.closest('.product-information') || swatchButton.closest('grid-item');
    if (container) {
      container.querySelectorAll('[data-swatch-button]').forEach(btn => {
        btn.classList.remove('is-selected');
      });
      swatchButton.classList.add('is-selected');

      const variantName = swatchButton.getAttribute('data-swatch-variant-name');
      const nameDisplay = container.querySelector('[data-variant-name-display]');
      
      if (nameDisplay && variantName) {
        nameDisplay.style.opacity = '0.3';
        setTimeout(() => {
          nameDisplay.textContent = variantName;
          nameDisplay.style.opacity = '1';
        }, 100);
      }

      // CUSTOM CODE - Update quick-add variant 
      const variantId = swatchButton.getAttribute('data-swatch-variant') || swatchButton.getAttribute('data-variant');
      const variantAvailable = swatchButton.getAttribute('data-variant-available') === 'true';
      
      if (variantId) {
        const productItem = container.closest('[data-grid-item]') || container;
        const variantInput = productItem.querySelector('[data-quick-add-variant]');
        const addToCartButton = productItem.querySelector('[data-add-to-cart]');
        
        if (variantInput) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (addToCartButton) {
          if (variantAvailable) {

            addToCartButton.classList.remove('is-disabled');
            addToCartButton.removeAttribute('aria-disabled');
            addToCartButton.type = 'submit';
            
            const btnText = addToCartButton.querySelector('.btn__text');
            if (btnText) {
              const addToCartText = addToCartButton.getAttribute('data-add-to-cart-text') || addToCartButton.getAttribute('aria-label') || 'Add to cart';
              btnText.textContent = addToCartText;
            }
          } else {
            addToCartButton.classList.add('is-disabled');
            addToCartButton.setAttribute('aria-disabled', 'true');
            addToCartButton.type = 'button';
            const btnText = addToCartButton.querySelector('.btn__text');
            if (btnText) {
              const soldOutText = addToCartButton.getAttribute('data-sold-out-text') || 'Sold out';
              btnText.textContent = soldOutText;
            }
          }
        }
      }
      // END CUSTOM CODE
    }
  }
}, true);

// CUSTOM CODE
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('[data-swatch-button]');
  if (!swatch) return;

  const productItem = swatch.closest('[data-grid-item]');
  if (!productItem) return;

  const newPrice = swatch.dataset.variantPrice;
  const newComparePrice = swatch.dataset.variantCompare_at_price;

  const priceHolder = productItem.querySelector('[data-product-price]');
  if (!priceHolder) return;

  const newPriceEl = priceHolder.querySelector('.new-price') || priceHolder;
  if (newPrice) {
    newPriceEl.textContent = newPrice;
  }

  let oldPriceEl = priceHolder.querySelector('.old-price');

  if (newComparePrice && newComparePrice !== newPrice) {
    if (!oldPriceEl) {
      oldPriceEl = document.createElement('span');
      oldPriceEl.className = 'old-price';
      priceHolder.appendChild(oldPriceEl);
    }
    oldPriceEl.textContent = newComparePrice;
    oldPriceEl.style.display = '';
  } else if (oldPriceEl) {
    oldPriceEl.style.display = 'none';
  }
  
  if (!newComparePrice) {
    newPriceEl.style.color = 'black'
  } else {
    newPriceEl.style.color = 'red'
  }

}, true);

// END CUSTOM CODE
  } catch(e) { console.error(e); }
})();

})();
